import storage from 'store'
import { login, getInfo, logout } from '@/api/login'
import { ACCESS_TOKEN, LonLat } from '@/store/mutation-types'
import { welcome } from '@/utils/util'
import axios from 'axios'
const user = {
  state: {
    token: '',
    name: '',
    headUrl: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {}
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, {
      name,
      welcome
    }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_URL: (state, headUrl) => {
      state.headUrl = headUrl
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    // 登录
    Login ({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          const result = response.data
          storage.set(ACCESS_TOKEN, 'Bearer ' + result.access_token, 7 * 24 * 60 * 60 * 1000)
          commit('SET_TOKEN', 'Bearer ' + result.access_token)
          storage.set('tenantId', result.tenantId, 7 * 24 * 60 * 60 * 1000)
          commit('SET_TENANT_ID', result.tenantId)

          axios.defaults.headers.common['tenantId'] = result.tenantId
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo ({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const result = response.data
          // logo去除 2023年7月6日09:17:16
          if (process.env.VUE_APP_LOGO === 'false') {
            response.data.tenant.shortName = '某某水司'
          }
          storage.set(LonLat, response.data.tenant.point)
          if (result.role && result.role.permissions.length > 0) {
            const role = result.role
            role.permissions = result.role.permissions
            role.permissions.map(per => {
              if (per.actionEntitySet != null && per.actionEntitySet.length > 0) {
                const action = per.actionEntitySet.map(action => {
                  return action.action
                })
                per.actionList = action
              } else {
                per.actionList = []
              }
            })
            role.permissionList = role.permissions.map(permission => {
              return permission.permissionId
            })
            localStorage.setItem('tenant-user', result.tenant.tenantId + '_' + result.username)
            commit('SET_ROLES', result.role)
            commit('SET_INFO', result)
          } else {
            reject(new Error('getInfo: roles must be a non-null array !'))
          }
          commit('SET_NAME', { name: result.name, welcome: welcome() })
          commit('SET_URL', result.headUrl)
          commit('SET_AVATAR', result.avatar)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout ({
      commit,
      state
    }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        storage.remove(ACCESS_TOKEN)
        storage.remove(LonLat)
        // 清除localStorage相关key
        localStorage.removeItem('tenant-user')
        localStorage.removeItem('systemName')
        // 清除storage库相关key
        storage.remove('tenantId')
        storage.remove('SIDEBAR_TYPE')
        storage.remove('TOGGLE_NAV_THEME')
        storage.remove('TOGGLE_LAYOUT')
        storage.remove('TOGGLE_FIXED_HEADER')
        storage.remove('TOGGLE_FIXED_SIDEBAR')
        storage.remove('TOGGLE_CONTENT_WIDTH')
        storage.remove('TOGGLE_HIDE_HEADER')
        storage.remove('TOGGLE_COLOR')
        storage.remove('TOGGLE_WEAK')
        storage.remove('APP_LANGUAGE')
        storage.remove('TOGGLE_MULTI_TAB')
        storage.remove('lang')
        // 清除sessionStorage相关key
        sessionStorage.removeItem('shuzhi')
        // 清除所有业务相关key
        const keysToRemove = [
          'Login', 'app_language', 'color', 'content_width', 'env', 'fixed_header', 'fixed_sidebar',
          'lang', 'layout', 'nav_theme', 'sidebar_type', 'username', 'weak', 'zoneId', 'zoneName'
        ]
        keysToRemove.forEach(key => localStorage.removeItem(key))
        resolve()
      })
    }

  }
}

export default user
